import { ACTION_TYPES } from "../constants/actionTypes";

export const appLogout = () => ({
  type: ACTION_TYPES.APP.LOGOUT,
});

export const setLoading = (data) => ({
  type: ACTION_TYPES.APP.SET_LOADING,
  data,
});

export const setIsLogin = (data) => ({
  type: ACTION_TYPES.APP.SET_IS_LOGIN,
  data,
});

export const setRequestId = (data) => ({
  type: ACTION_TYPES.APP.SET_REQUEST_ID,
  data,
});

export const setUserOnDashboard = (data) => ({
  type: ACTION_TYPES.APP.USER_ON_DASHBOARD,
  data,
});

export const setUserCurrentScreen = (data) => ({
  type: ACTION_TYPES.APP.USER_CURRENT_SCREEN,
  data,
});

export const setSelectedRiskIndex = (data) => ({
  type: ACTION_TYPES.APP.SELECTED_RISK_INDEX,
  data,
});

export const loginInit = (data) => ({
  data,
  type: ACTION_TYPES.APP.LOGIN.INIT,
});

export const loginSuccess = (data) => ({
  data,
  type: ACTION_TYPES.APP.LOGIN.SUCCESS,
});

export const loginFail = (errors) => ({
  data: errors,
  type: ACTION_TYPES.APP.LOGIN.FAIL,
});

export const dashboardInit = (data) => ({
  data,
  type: ACTION_TYPES.APP.DASHBOARD.INIT,
});

export const dashboardSuccess = (data) => ({
  data,
  type: ACTION_TYPES.APP.DASHBOARD.SUCCESS,
});

export const dashboardFail = (errors) => ({
  data: errors,
  type: ACTION_TYPES.APP.DASHBOARD.FAIL,
});

export const updateUserProfileInit = (data) => ({
  data,
  type: ACTION_TYPES.APP.USER_PROFILE.INIT,
});

export const updateUserProfileSuccess = (data) => ({
  data,
  type: ACTION_TYPES.APP.USER_PROFILE.SUCCESS,
});

export const updateUserProfileFail = (errors) => ({
  data: errors,
  type: ACTION_TYPES.APP.USER_PROFILE.FAIL,
});
